import CVTitle from './CVTitle'

export default CVTitle
